export enum AgencyPageView {
  AssociatedCompanies = 'customers',
  AssignedUsers = 'users',
}
